<ng-container *transloco="let t; read: 'mailNotifierTopHeader'">
  <button
    mat-icon-button
    [matMenuTriggerFor]="menu"
    [matBadge]="count"
    matBadgeColor="warn"
    matBadgeOverlap="true"
    matBadgeSize="small"
    [matBadgeHidden]="count === 0 || count === null"
    class="button"
  >
    <mat-icon class="-header-icon">mail</mat-icon>
  </button>
  <mat-menu #menu="matMenu" class="emails">
    <mat-table *ngIf="emails?.data.length > 0; else empty" [dataSource]="emails.data">
      <ng-container matColumnDef="studentId">
        <mat-header-cell *matHeaderCellDef>{{ t('student') }}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.studentId }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="educationServiceId">
        <mat-header-cell *matHeaderCellDef>{{ t('service') }}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.educationServiceId }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="updatedAt">
        <mat-header-cell *matHeaderCellDef>{{ t('date') }}</mat-header-cell>
        <mat-cell *matCellDef="let row">{{ row.updatedAt | date: 'short' }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="open(row)"
        class="row"
        matRipple
        [matRippleRadius]="200"
      ></mat-row>
    </mat-table>

    <ng-template #empty>
      <div class="no-content">
        <crm-no-content>
          <ng-container icon>mail_outline</ng-container>
          <ng-container text>{{ t('noMails') }}</ng-container>
        </crm-no-content>
      </div>
    </ng-template>
  </mat-menu>
</ng-container>
